module.exports = __webpack_public_path__ + "static/media/whyus5.2ac1b6b6.png";